export const STAT_BAR_FACTOR = 1.5;

export const SLIDE_ANIMATION_TIME = 1000;

export const FIRST_POKEMON_ID = 1;
export const LAST_POKEMON_ID = 905;
export const PAGE_SIZE = 10;
export const FIRST_PAGE = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
export const SECOND_PAGE = [11, 12, 13, 14, 15, 16, 17, 18, 19, 20];
export const SEMI_FINAL_PAGE = [891, 892, 893, 894, 895, 896, 897, 898, 899, 900];
export const FINAL_PAGE = [901, 902, 903, 904, 905];
